export function show() {
  const appLoader = document.getElementById("app-loader") as HTMLElement;
  appLoader.style.display = "block";
}
export function hide() {
  const appLoader = document.getElementById("app-loader") as HTMLElement;
  appLoader.style.display = "none";
}
